import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { clone, DEFAULT_IMAGE_LAYER, DEFAULT_SIMPLE_LAYER, DEFAULT_TRAIL, } from "@erikwatson/snowfall";
import { isSimpleLayer } from "@erikwatson/snowfall";
import { faCircle, faImage, faTrash, faUndo, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../button/button";
import { Control } from "../../control/control";
import { ControlGroup } from "../../controlGroup/controlGroup";
import { Group } from "../../group/group";
import { Layer } from "../../layer/layer";
import { useDispatch } from "react-redux";
import { SnowflakeColour } from "./colour/colour";
import { SnowflakeDensity } from "./density/density";
import { SnowflakeMass } from "./mass/mass";
import { SnowflakeGravityAngle } from "./gravity-settings/angle/angle";
import { SnowflakeGravityStrength } from "./gravity-settings/strength/strength";
import { SnowflakeSwayFrequency } from "./sway-settings/frequency/frequency";
import { SnowflakeSwayAmplitude } from "./sway-settings/amplitude/amplitude";
import { SnowflakeWindAngle } from "./wind-settings/angle/angle";
import { SnowflakeWindStrength } from "./wind-settings/strength/strength";
import { SnowflakeGustActive } from "./gust-settings/active";
import { SnowflakeGustChangeChange } from "./gust-settings/change-chance";
import { SnowflakeGustAdditionalStrength } from "./gust-settings/additional-strength";
import { SnowflakeGustInDelay } from "./gust-settings/in-delay";
import { SnowflakeGustInDuration } from "./gust-settings/in-duration";
import { SnowflakeGustOutDelay } from "./gust-settings/out-delay";
import { SnowflakeGustOutDuration } from "./gust-settings/out-duration";
import { Text } from "../../text/text";
import { useEffect, useState } from "react";
import "./layer-settings.css";
import { addLayer, duplicateLayer, removeLayer, resetLayer, resetLayers, resetUserConfig, setUserConfig, moveLayerDown, moveLayerUp, setLayerRotation, setLayerImage, setTrail, setLayerScroll } from "../../../features/config/config.slice";
// import {} from '../../../features/config/'
import { PRESET_SNOW } from "../../../presets/snow";
import { resetEditorSettings, setEditorSettings, } from "../../../features/editor-settings/editor-settings.slice";
import { PRESET_LAVA } from "../../../presets/lava";
import { PRESET_FALLOUT } from "../../../presets/fallout";
import { PRESET_SPACE } from "../../../presets/space";
import { CheckBox } from "../../checkbox/checkbox";
import { SnowflakeSize } from "./size/size";
import { SnowflakeOpacity } from "./opacity/opacity";
export let cachedLayerTitles = null;
function layerName(layers, index) {
    return layers?.[index].mode === "simple"
        ? `Simple layer ${index + 1}`
        : `Image layer ${index + 1}`;
}
export const LayerSettings = ({ layers, advancedSettings, preset, }) => {
    const dispatch = useDispatch();
    const layerTitles = layers?.map((x, i) => {
        return x.mode === "simple"
            ? `Simple layer ${i + 1}`
            : `Image layer ${i + 1}`;
    });
    const [titles, setTitles] = useState(layerTitles);
    // Sync titles with layerTitles when layers change
    useEffect(() => {
        if (cachedLayerTitles) {
            setTitles(layerTitles);
            cachedLayerTitles = layerTitles ?? null;
        }
    }, [layers]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "layers-header", children: [_jsx("h2", { children: "Layer settings" }), _jsxs("div", { children: [_jsxs(Button, { kind: "normal_fat", tooltip: "New simple layer", onClick: () => {
                                    dispatch(addLayer(DEFAULT_SIMPLE_LAYER));
                                    setTitles((titles) => {
                                        titles = titles || [];
                                        const name = `Simple layer ${titles.length + 1}`;
                                        return [...titles, name];
                                    });
                                }, children: ["New ", _jsx(FontAwesomeIcon, { icon: faCircle })] }), _jsxs(Button, { kind: "normal_fat", tooltip: "New image layer", onClick: () => {
                                    dispatch(addLayer(DEFAULT_IMAGE_LAYER));
                                    setTitles((titles) => {
                                        titles = titles || [];
                                        const name = `Image layer ${titles.length + 1}`;
                                        return [...titles, name];
                                    });
                                }, children: ["New ", _jsx(FontAwesomeIcon, { icon: faImage })] }), _jsx(Button, { tooltip: "Reset to preset", kind: "error", onClick: () => {
                                    const value = preset === "snow"
                                        ? PRESET_SNOW
                                        : preset === "lava"
                                            ? PRESET_LAVA
                                            : preset === "space"
                                                ? PRESET_SPACE
                                                : preset === "fallout"
                                                    ? PRESET_FALLOUT
                                                    : null;
                                    if (value) {
                                        dispatch(setUserConfig(value.userConfig));
                                        dispatch(setEditorSettings(value.editorConfig));
                                    }
                                    else {
                                        dispatch(resetUserConfig());
                                        dispatch(resetEditorSettings());
                                    }
                                    cachedLayerTitles = null;
                                    setTitles(layerTitles);
                                }, children: _jsx(FontAwesomeIcon, { icon: faUndo }) }), _jsx(Button, { tooltip: "Remove all layers", kind: "error", onClick: () => {
                                    dispatch(resetLayers());
                                }, children: _jsx(FontAwesomeIcon, { icon: faTrash }) })] })] }), layers?.length === 0 && (_jsxs("div", { className: "empty-layers", children: [_jsx("p", { children: "No layers yet." }), _jsx("p", { children: "Add one to get started!" })] })), layers
                ?.map((x, i) => {
                const result = clone(x);
                result.id = i;
                return result;
            })
                ?.map((layer, index) => (_jsx(_Fragment, { children: _jsxs(Layer, { colour: "grey-2", id: index, size: layers.length - 1, name: titles
                        ? titles[index]
                        : layerName(layers, index), mode: layer.mode, remove: () => {
                        dispatch(removeLayer(index));
                    }, duplicate: () => {
                        dispatch(duplicateLayer(index));
                    }, reset: () => {
                        dispatch(resetLayer(index));
                        setTitles((prev) => prev && prev.length
                            ? prev.toSpliced(index, 1, layerName(layers, index))
                            : prev);
                    }, layerUp: () => {
                        dispatch(moveLayerUp({ index }));
                        setTitles((prevTitles) => {
                            prevTitles = prevTitles || [];
                            const newTitles = [...prevTitles];
                            [newTitles[index], newTitles[index - 1]] = [
                                newTitles[index - 1],
                                newTitles[index],
                            ];
                            return newTitles;
                        });
                    }, layerDown: () => {
                        dispatch(moveLayerDown({ index }));
                        setTitles((prevTitles) => {
                            prevTitles = prevTitles || [];
                            const newTitles = [...prevTitles];
                            [newTitles[index], newTitles[index + 1]] = [
                                newTitles[index + 1],
                                newTitles[index],
                            ];
                            return newTitles;
                        });
                    }, children: [_jsx(ControlGroup, { children: _jsx(Control, { name: "Title", onChange: (event) => {
                                    setTitles((titles) => {
                                        const newTitles = [...(titles || [])];
                                        newTitles[index] = event.target.value;
                                        return newTitles;
                                    });
                                }, reset: () => {
                                    setTitles((titles) => {
                                        const newTitles = [...(titles || [])];
                                        newTitles[index] = layerName(layers, index);
                                        return newTitles;
                                    });
                                }, value: titles
                                    ? titles[index]
                                    : layerName(layers, index), children: _jsx(Text, {}) }) }), _jsxs(Group, { name: "Snow", colour: "secondary", children: [isSimpleLayer(layer) && (_jsx(SnowflakeColour, { layer: layer, index: index })), !isSimpleLayer(layer) && (_jsx(_Fragment, { children: _jsx(Control, { name: "Image", tooltip: "Upload an image file", reset: () => { }, value: layer.image, onChange: (event) => {
                                            const input = event.target;
                                            const file = input.files?.[0]; // Access files safely
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.onload = () => {
                                                    const base64String = reader.result; // Base64 encoded image
                                                    dispatch(setLayerImage({ index, image: base64String }));
                                                };
                                                reader.readAsDataURL(file);
                                            }
                                        }, children: _jsx("input", { type: "file", accept: "image/*" }) }) })), _jsx(SnowflakeDensity, { layer: layer, index: index }), isSimpleLayer(layer) && (_jsx(Control, { name: "Trail", tooltip: "Draw a small motion trail behind the snowflakes?", reset: () => {
                                        dispatch(setTrail({ index, trail: DEFAULT_TRAIL }));
                                    }, value: layer.trail, onChange: (event) => {
                                        dispatch(setTrail({
                                            index,
                                            trail: event.target.checked,
                                        }));
                                    }, children: _jsx(CheckBox, {}) })), _jsx(SnowflakeMass, { layer: layer, index: index }), _jsx(SnowflakeSize, { layer: layer, index: index }), _jsx(SnowflakeOpacity, { layer: layer, index: index })] }), _jsxs(Group, { name: "Motion", colour: "secondary", children: [!isSimpleLayer(layer) && (_jsx(Control, { name: "Rotate", tooltip: "Should the snowflakes rotate or not?", reset: () => {
                                        //
                                    }, value: layer.rotate, onChange: (event) => {
                                        dispatch(setLayerRotation({
                                            index,
                                            rotate: event.target.checked,
                                        }));
                                    }, children: _jsx(CheckBox, {}) })), _jsx(Control, { name: "Scroll", tooltip: "Should the snowflakes scroll with the page or not?", reset: () => {
                                        //
                                    }, value: (layer).scroll, onChange: (event) => {
                                        dispatch(setLayerScroll({
                                            index,
                                            scroll: event.target.checked,
                                        }));
                                    }, children: _jsx(CheckBox, {}) }), advancedSettings && (_jsx(Group, { name: "Gravity", colour: "grey-2", children: _jsxs(ControlGroup, { children: [_jsx(SnowflakeGravityAngle, { layer: layer, index: index }), _jsx(SnowflakeGravityStrength, { layer: layer, index: index })] }) })), advancedSettings && (_jsx(Group, { name: "Sway", colour: "grey-2", children: _jsxs(ControlGroup, { children: [_jsx(SnowflakeSwayAmplitude, { layer: layer, index: index }), _jsx(SnowflakeSwayFrequency, { layer: layer, index: index })] }) })), _jsxs(Group, { name: "Wind", colour: "grey-2", children: [_jsxs(ControlGroup, { children: [advancedSettings && (_jsx(SnowflakeWindAngle, { layer: layer, index: index })), _jsx(SnowflakeWindStrength, { layer: layer, index: index })] }), _jsxs(Group, { name: "Gusts", colour: "secondary", children: [_jsxs(ControlGroup, { children: [_jsx(SnowflakeGustActive, { layer: layer, index: index }), layer.wind.gusts.active && (_jsx(SnowflakeGustChangeChange, { layer: layer, index: index }))] }), layer.wind.gusts.active && advancedSettings && (_jsxs(_Fragment, { children: [_jsxs(Group, { name: "In", colour: "grey-2", children: [_jsx(SnowflakeGustAdditionalStrength, { layer: layer, index: index }), _jsx(SnowflakeGustInDelay, { layer: layer, index: index }), _jsx(SnowflakeGustInDuration, { layer: layer, index: index })] }), _jsxs(Group, { name: "Out", colour: "grey-2", children: [_jsx(SnowflakeGustOutDelay, { layer: layer, index: index }), _jsx(SnowflakeGustOutDuration, { layer: layer, index: index })] })] }))] })] })] })] }, index) })))] }));
};
